import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const AuthHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogoClick = () => {
    const isLoggedIn = localStorage.getItem("authToken");
    navigate(isLoggedIn ? "/dashboard" : "/");
  };

  return (
    <>
      <header className="w-full flex items-center justify-between px-6 py-6 bg-[#fdf6ee]">
        <div className="flex items-center gap-4">
          <button onClick={() => setMenuOpen(true)} className="text-black">
            <span className="sr-only">Open menu</span>
            <i className="text-2xl">☰</i>
          </button>
          <div
            onClick={handleLogoClick}
            className="text-xl font-bold cursor-pointer hover:opacity-80 transition"
          >
            FullPlateNow
          </div>
        </div>

        {/* Desktop login and link-style sign up */}
        <div className="hidden md:flex items-center space-x-4">
          <Link to="/login">
            <button className="bg-white text-black rounded-full px-4 py-2 shadow-sm hover:shadow-md transition">
              Log in
            </button>
          </Link>
          <Link
            to="/signup"
            className="flex items-center text-sm font-medium text-black hover:text-[#FF5A5F] transition"
          >
            Sign up
            <ExternalLink className="w-4 h-4 ml-1 stroke-[2]" />
          </Link>
        </div>
      </header>

      {/* Slide-out Mobile Menu */}
      {menuOpen && (
        <div className="fixed inset-0 z-50 flex">
          <aside className="w-80 bg-white p-6 flex flex-col justify-between shadow-2xl border-r border-gray-200">
            {/* Top */}
            <div className="space-y-6">
              <div>
                <h2 className="text-sm text-gray-400 mb-1">Welcome</h2>
                <p className="text-lg font-semibold text-gray-800 leading-tight">
                  Your delivery, unified.
                </p>
              </div>

              <nav className="space-y-3">
                <Link
                  to="/become-partner"
                  className="block text-black hover:text-[#FF5A5F] font-medium text-sm transition"
                >
                  → Become a partner
                </Link>
                <Link
                  to="/platform"
                  className="block text-black hover:text-[#FF5A5F] font-medium text-sm transition"
                >
                  → How it works
                </Link>
                <Link
                  to="/careers"
                  className="block text-black hover:text-[#FF5A5F] font-medium text-sm transition"
                >
                  → Careers
                </Link>
              </nav>
            </div>

            {/* Bottom */}
            <div className="mt-12 border-t pt-6">
              <div className="flex items-center gap-4">
                <div className="bg-[#FF5A5F] text-white p-2 rounded-md">
                  <span className="text-xl">🍽️</span>
                </div>
                <p className="text-sm text-black">Your restaurant. Anywhere.</p>
              </div>
              <div className="flex gap-3 mt-4">
                <button className="bg-gray-100 text-black px-4 py-2 rounded-full text-sm hover:bg-gray-200 transition">
                   iPhone
                </button>
                <button className="bg-gray-100 text-black px-4 py-2 rounded-full text-sm hover:bg-gray-200 transition">
                  🤖 Android
                </button>
              </div>
            </div>
          </aside>

          <div
            className="flex-1 bg-black/50"
            onClick={() => setMenuOpen(false)}
          />
        </div>
      )}
    </>
  );
};

export default AuthHeader;
